import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { headervalue } from 'src/headervalue/header';
import {Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })


export class DashboardService {
  url: string;
  constructor(private http: HttpClient) { }

  getYear()
  {
    var temp = this.http.get<any>(`${environment.apiUrl}/FinancialYear/getList`,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  getRequestStatitics(year) {
    var temp = this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getRequestStatitics/`+year,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  
  getTopTenEmployer(year) {
    var temp = this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getTopTenEmployer/`+year,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  
  getRequestratio(year) {
    var temp = this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getRequestratio/`+year,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    console.log("temp of request ratio---->", temp);
    return temp;
  }
  
  getYearRevenue() {
    var temp = this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getYearRevenue`,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  
  getDisputeRatio(year) {
    var temp = this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getDisputeRatio/`+year,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    console.log("temp of dispute ratio---->", temp);
    return temp;
  }

  getFinancialStat(firstdate,lastdate) {
    var temp = this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getFinancialStat/`+firstdate+'/'+lastdate,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  
  getOnlineVerifiers(firstdate,lastdate) {
    var temp = this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getPerformanceGraphCustomRange/`+firstdate+'/'+lastdate,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }

  getPerformanceGraphMonthly(monthYr) {
    var temp = this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getPerformanceGraphMonthly/`+monthYr,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }

  getPerformanceGraphDaily(date) {
    var temp = this.http.get<any>(`${environment.apiUrl}/AdminDashboard/getPerformanceGraphDaily/`+date,{ headers:  new HttpHeaders( headervalue.headerWithJwt)  });
    return temp;
  }
  
}